import { useCallback, useEffect } from 'react'
import { getSubmit } from "@ui-seeker/utils"
import { useSignal } from "@preact/signals-react"
import { useToast } from "@hooks"
import { adminIdStatusReportList, tabSelected, tableReportData, clearSignals } from 'Pages/Admin/GlobalExecution/@signals'
import { useReportBackendApiPath } from "Pages/Admin/GlobalExecution/Reports/@hooks/index"

export default function useTable() {
	const isTableLoading = useSignal(false)
	const { executionStatus } = useReportBackendApiPath()
	const { showToast } = useToast()

	const getData = useCallback(() => {
		isTableLoading.value = true
		getSubmit(executionStatus).then(res => {
			adminIdStatusReportList.value = res.map(({ id_last_execution }) => id_last_execution)
			tableReportData.value = res
			isTableLoading.value = false
		}).catch(() => {
			showToast.error()
			isTableLoading.value = false
		})
	}, [tabSelected.value])

	useEffect(() => {
		clearSignals()
		getData()
	}, [tabSelected.value])

	return {
		tableReportData: tableReportData.value,
		isTableLoading: isTableLoading.value,
	}
}